import { defineStore } from 'pinia';
import genericAPI from "@/api/api";
import type { ZUser } from "@schemas/user.schemas";
export const useUserStore = defineStore('user', {
    state: () => ({
        users: [] as ZUser[],
        currentUser: null as ZUser | null
    }),
    actions: {
        clearMyData(): void {
            this.currentUser = null;
        },
        /**
         * Fetch the current user from the backend
         * If force is true, the user will be fetched from the backend even if it is already in the store
         * @param force
         */
        async fetchCurrentUser(force: boolean = false): Promise<ZUser> {
            if (!this.currentUser || force) {
                this.currentUser = await genericAPI.getDocument<ZUser>('users', 'current');
            }
            return this.currentUser;
        },
        async fetchUser(userId: string): Promise<ZUser> {
            this.currentUser = this.users.find(app => app._id === userId) ||
                await genericAPI.getDocument<ZUser>('users', userId);
            return this.currentUser
        },
        async fetchUsers(): Promise<ZUser[]> {
            this.users = await genericAPI.getDocuments<ZUser>('users');
            return this.users;
        },
        async createUser(user: ZUser): Promise<ZUser> {
            const newUser = await genericAPI.postDocument<ZUser>('users', user);
            this.users.push(newUser);
            return newUser;
        },
        async updateUser(user: ZUser): Promise<ZUser> {
            const updatedUsers = await genericAPI.putDocument<ZUser>('users', user);
            this.users = this.users.map(user => user._id === updatedUsers._id ? updatedUsers : user);
            // TODO if currentUser is updated, update it as well
            return updatedUsers
        },
        async deleteUser(userId: string): Promise<void> {
            await genericAPI.deleteDocument<ZUser>('users', userId);
            this.users = this.users.filter(user => user._id !== userId);
        }
    }
});
